export default __webpack_public_path__ + "static/media/piece--240.8b3ab9a7.jpg";